import {
  FETCH_FEES,
  FETCH_FEES_FAILURE,
  FETCH_FEES_SUCCESS,
  REFRESH_STATEMENT_URL,
  SET_PREAUTH_FEE_SCHEDULES,
} from './constants';

export function fetchFees({ isLoggedIn, loanNumber }) {
  return {
    payload: { isLoggedIn, loanNumber },
    type: FETCH_FEES,
  };
}

export function fetchFeesFailure({
  asOfDate,
  disclaimer,
  feeSchedule,
}) {
  return {
    payload: {
      asOfDate,
      disclaimer,
      feeSchedule,
    },
    type: FETCH_FEES_FAILURE,
  };
}

export function fetchFeesSuccess({
  asOfDate,
  disclaimer,
  feeSchedule,
  statementUrl,
}) {
  return {
    payload: {
      asOfDate,
      disclaimer,
      feeSchedule,
      statementUrl,
    },
    type: FETCH_FEES_SUCCESS,
  };
}

export function refreshStatementUrl() {
  return { type: REFRESH_STATEMENT_URL };
}

export function setPreAuthFeeShedules({ feeStatements }) {
  return {
    payload: { feeStatements },
    type: SET_PREAUTH_FEE_SCHEDULES,
  };
}
